import { createTheme } from '@mui/material';

const theme = createTheme({
  palette: {
    primary: { main: '#000000' },
    text: {
      primary: '#000000',
    },
    secondary: {
      main: '#e61464',
    },
    error: {
      main: '#d50000',
    },
  },
  typography: {
    fontFamily: 'Interstate',
  },
  /* overrides: {
    MuiOutlinedInput: {
      root: {
        'fontWeight': 700,
        '&:hover:not($disabled):not($focused):not($error) $notchedOutline': {
          borderColor: '#0f5485',
          opacity: 0.8,
        },
      },
      disabled: {},
      focused: {},
      error: {},
      notchedOutline: {},
    },
  }, */
  breakpoints: {
    values: {
      xs: 0,
      sm: 375,
      md: 768,
      lg: 1280,
      xl: 1920,
    },
  },
});

export default theme;
